
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Badge, Tab, Nav } from 'react-bootstrap';
import { TbEdit, TbMessage, TbChevronDown } from 'react-icons/tb';

import EmployeeDetailsHeader from '../../../components/hrm/employees/EmployeeDetailsHeader.jsx'
import EmployeeLeftSidebar from '../../../components/hrm/employees/EmployeeLeftSidebar.jsx';
import EmployeeRightContent from '../../../components/hrm/employees/EmployeeRightContent.jsx';
import EditEmployeeModal from '../../../components/modals/hrm/employee/employeedetails/EditEmployeeModal.jsx';
const EmployeesDetailsPage = () => {
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <Container 
style={{ padding: "15px", background: "#f8f9fa",  }} fluid className="p-3 p-md-4">
       <EmployeeDetailsHeader />
      <Row>
        {/* Left Sidebar */}
        <Col xl={4} lg={5} className="mb-4 mb-xl-0">
          <EmployeeLeftSidebar onEditClick={() => setShowEditModal(true)} />
        </Col>

        {/* Right Content */}
        <Col xl={8} lg={7}>
          <EmployeeRightContent onEditClick={() => setShowEditModal(true)} />
        </Col>
      </Row>

      {/* Global Edit Modal */}
      <EditEmployeeModal
        show={showEditModal} 
        onHide={() => setShowEditModal(false)} 
      />
    </Container>
  );
};

export default EmployeesDetailsPage;
